import i18n from 'i18next';
import { ServiceError, ServiceErrorErrorEnum } from '@cdaas/api-clients/dist/product-service-openapi/api';
import { AxiosResponse, isAxiosError } from 'axios';

/**
 * Map error code returned from backend into a localized error message
 * @param backendError Error object returned from backend
 * @param defaultMessage Error message to return if the backendError is not of any specific type
 */
export const mapBackendErrorCodeToLocalizedErrorMsg = (backendError: ServiceError | undefined, defaultMessage = ''): string => {
  const i18nNamespace = 'errorCodes';
  switch (backendError?.error) {
    case ServiceErrorErrorEnum.InvalidId:
      return i18n.t(`${i18nNamespace}:invalidId`);
    case ServiceErrorErrorEnum.LocaleNotSupported:
      return i18n.t(`${i18nNamespace}:localeNotSupported`);
    case ServiceErrorErrorEnum.InvalidCountry:
      return i18n.t(`${i18nNamespace}:invalidCountry`);
    case ServiceErrorErrorEnum.InvalidValue:
      return i18n.t(`${i18nNamespace}:invalidValue`);
    case ServiceErrorErrorEnum.InvalidState:
      return i18n.t(`${i18nNamespace}:invalidState`);
    case ServiceErrorErrorEnum.DataIntegrityViolation:
      return i18n.t(`${i18nNamespace}:dataIntegrityViolation`);
    case ServiceErrorErrorEnum.ConstraintViolation:
      return i18n.t(`${i18nNamespace}:constraintViolation`);
    case ServiceErrorErrorEnum.SkuAlreadyExists:
      return i18n.t(`${i18nNamespace}:skuAlreadyExists`);
    case ServiceErrorErrorEnum.DuplicateLocales:
      return i18n.t(`${i18nNamespace}:duplicateLocales`);
    case ServiceErrorErrorEnum.DuplicateProductProperties:
      return i18n.t(`${i18nNamespace}:duplicateProductProperties`);
    case ServiceErrorErrorEnum.DuplicateVariantProperties:
      return i18n.t(`${i18nNamespace}:duplicateVariantProperties`);
    case ServiceErrorErrorEnum.DuplicatePrices:
      return i18n.t(`${i18nNamespace}:duplicatePrices`);
    default:
      return defaultMessage || i18n.t(`${i18nNamespace}:general`);
  }
};

/**
 * Resolve error data response object from an Axios error.
 * @param error Axios response data object, or undefined if response data is missing or error is not an Axios error object.
 */
export const resolveAxiosErrorResponse = (error: unknown): AxiosResponse | undefined => (isAxiosError(error) ? error.response : undefined);
